import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import styles from './Button.module.css'

type Variante = 'primary' | 'secondary' | 'ghost' | 'danger'
type Taglia = 'sm' | 'md' | 'lg'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante
  taglia?: Taglia
  iconaSinistra?: ReactNode
  iconaDestra?: ReactNode
  caricamento?: boolean
}

export function Button({
  variante = 'primary',
  taglia = 'md',
  iconaSinistra,
  iconaDestra,
  caricamento,
  disabled,
  children,
  className,
  ...rest
}: Props) {
  const classi = [styles.btn, styles[variante], styles[taglia], className].filter(Boolean).join(' ')
  return (
    <button className={classi} disabled={disabled || caricamento} {...rest}>
      {iconaSinistra && <span className={styles.icon}>{iconaSinistra}</span>}
      <span>{caricamento ? 'Attendi…' : children}</span>
      {iconaDestra && <span className={styles.icon}>{iconaDestra}</span>}
    </button>
  )
}
